<template>

  <v-container v-show="isMounted" >


    <v-layout row align-center justify-center>
<img src="http://localhost:8088/app/vue/static/images/login/logo.png" class="logo" alt="">
</v-layout>
    <div class="text-xs-center">
      <h2>REGÍSTRATE <br>COMO COMERCIANTE</h2> 
    </div>
    <v-layout row align-center justify-center>
        <vuetify-form-creator
          :columns="'xs12 sm12 md12 lg12'"
          :items="fields"
          ref="form"
        ></vuetify-form-creator>

    </v-layout>

  </v-container>

</template>

<script>
  import theme from 'config/theme'
  import VuetifyFormCreator from 'components/vuetify-form-creator/vuetify-form-creator'
  import field from 'config/forms/validations'

  export default {
    components:
    {
      VuetifyFormCreator
    },

    data () {
      return {
        isMounted: false,
        fields: [
          {
            ref: 'name',
            type: 'text-field',
            label: 'Nombre',
            columns: 'xs12 sm12 md12 lg12',
            value: '',
            autocomplete: 'name',
            rules: [
              field.isRequired(),
              field.hasMaxLength(255),
              field.isComposedBy('letters|numbers|spaces')
            ],
            autofocus: true,
            counter: false,
            focusNextOnEnter: true,
            required: true,
            color: 'primary',
            dark: true
          },
          {
            ref: 'surname',
            type: 'text-field',
            label: 'Apellidos',
            columns: 'xs12 sm12 md12 lg12',
            value: '',
            autocomplete: 'family-name',
            rules: [
              field.isRequired(),
              field.hasMaxLength(255),
              field.isComposedBy('letters|numbers|spaces')
            ],
            counter: false,
            focusNextOnEnter: true,
            required: true,
            color: 'primary',
            dark: true
          },
          {
            ref: 'nif',
            type: 'text-field',
            label: 'DNI',
            columns: 'xs12 sm12 md6 lg6',
            value: '',
            autocomplete: 'cc-csc',
            rules: [
              field.isRequired(),
              field.isComposedBy('letters|numbers|spaces'),
              field.hasMaxLength(20)
            ],
            counter: false,
            focusNextOnEnter: true,
            required: true,
            color: 'primary',
            dark: true
          },
          {
            ref: 'email',
            type: 'text-field',
            label: 'Email',
            columns: 'xs12 sm12 md6 lg6',
            value: '',
            autocomplete: 'email',
            rules: [
              field.isEmail,
              field.hasMaxLength(255)
            ],
            counter: false,
            focusNextOnEnter: true,
            color: 'primary',
            dark: true
          },
          {
            ref: 'phone',
            type: 'select',
            label: 'Teléfonos',
            columns: 'xs12 sm12 md12 lg12',
            value: '',
            itemText: 'seller_name',
            itemValue: 'seller_name',
            avatars: false,
            options: [],
            default: {
              seller_id: '',
              seller_name: '',
              icon: 'phone',
              label: true,
              chipColor: 'primary',
              iconColor: 'white',
              textColor: 'white'
            },
            dark: true,
            rules: [
              field.isRequired(),
              field.hasLength(9, []),
              field.isComposedBy('numbers', [])
            ],
            required: true,
            autocomplete: true,
            multiple: true,
            disabled: false,
            chips: true,
            addOnEnter: true,
            hint: 'Pulsa enter para agregar un teléfono',
            noDataText: 'Pulsa enter para agregar un teléfono'
          }
        ]
      }
    },

    mounted () {
      this.isMounted = true
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCardStyle: function getCardStyle () {
        return 'theme--' + theme.route[this.$route.fullPath].styles.card
      },

      /**
       * Get custom parameters or use the default parameters.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      register: function register () {
        this.$store.dispatch('api/register', {
          passwordOne: this.passwordOne,
          passwordTwo: this.passwordTwo
        }).then(() => {
          if (this.$store.getters['api/isAuthorizedUser']) {
            return this.$router.push('/dashboard')
          }
          this.$store.dispatch(
            'snackbar/show',
            'Usuario o contraseña incorrectos'
          )
        })
      }
    }
  }
</script>

<style lang="sass">

#register-store-page
  background: #373c40
  height: 100%

  h2
   color: white
   padding: 20px
   font-size: 2.5em

  > .container

  .logo
    height: 200px
</style>



// WEBPACK FOOTER //
// src/pages/register-store.vue